module.exports = __webpack_public_path__ + "img/animated_logo.f34c4626.gif";